import React from 'react';
import ShareButtons from './ShareButtons';

interface FixedBottomActionAreaProps {
  contractorId: number;
  contractorName: string;
}

const FixedBottomActionArea: React.FC<FixedBottomActionAreaProps> = ({ contractorId, contractorName }) => {
  const url = `${window.location.origin}/contractors/${contractorId}`;
  return (
    <div className="fixed bottom-16 left-0 w-full px-4 py-3 bg-white/90 backdrop-blur-md z-30 md:hidden border-t border-outline-variant/30">
      <div className="flex items-center justify-between">
        <span className="text-sm text-on-surface-variant font-label-md">Share this contractor</span>
        <ShareButtons url={url} title={contractorName} />
      </div>
    </div>
  );
};

export default FixedBottomActionArea;
